import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=7dc19a52&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc19a52')) {
      api.createRecord('7dc19a52', component.options)
    } else {
      api.reload('7dc19a52', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=7dc19a52&", function () {
      api.rerender('7dc19a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wDeASB2jwI5H/JS/comp/ImgFallback.vue"
export default component.exports